/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Apr 04 2024
 **/

import { useDMRoomState, useSpaceRoomState } from "@/frameworks/core/chat";
import { ModalID } from "@/frameworks/core/commons";
import { Column, ModalPopup, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

export default function NoticeConfirmModal({
	roomID,
	spaceID,
	onSubmit,
	onCancel
}: {
	roomID: string;
	spaceID?: string;
	onSubmit: () => void;
	onCancel: () => void;
}) {
	const spaceChannel = useSpaceRoomState({ roomID, spaceID: spaceID ?? "" });
	const dmRoom = useDMRoomState(roomID);

	const hasNotice = spaceID ? spaceChannel?.notice !== undefined : dmRoom?.notice !== undefined;

	return (
		<ModalPopup
			modalID={ModalID.ALERT_CHAT_NOTIFICATION}
			fitContent
			cancelText={_T("취소")}
			confirmText={_T("등록하기")}
			onConfirm={onSubmit}
			onCancel={onCancel}
		>
			<Column>
				{hasNotice ? (
					<>
						<Typography.p align="center" typoColor="neutral_70_100" typoSize="Title1">
							{_T("상단 공지는 1개만 등록가능합니다.")}
						</Typography.p>
						<Typography.p align="center" typoColor="neutral_70_100" typoSize="Title1">
							{_T("공지를 변경하시겠습니까?")}
						</Typography.p>
					</>
				) : (
					<Typography.p align="center" typoColor="neutral_70_100" typoSize="Title1">
						{_T("공지사항을 등록하시겠습니까?")}
					</Typography.p>
				)}
			</Column>
		</ModalPopup>
	);
}
